module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fm-title"
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/fm03"
    }
  }, [_c('span', {
    staticClass: "toc-no"
  }, [_vm._v("Introduction")]), _vm._v(" "), _c('span', {
    staticClass: "titalic"
  }, [_vm._v("Secrets")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chap01"
    }
  }, [_c('span', {
    staticClass: "toc-no"
  }, [_vm._v("Chapter 1")]), _vm._v(" "), _c('span', {
    staticClass: "titalic"
  }, [_vm._v("The Set-Up")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-no"
  }, [_vm._v("Chapter 2")]), _vm._v(" "), _c('span', {
    staticClass: "titalic"
  }, [_vm._v("Love and Loss")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-no"
  }, [_vm._v("Chapter 3")]), _vm._v(" "), _c('span', {
    staticClass: "titalic"
  }, [_vm._v("The Story I Never Expected")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-no"
  }, [_vm._v("Chapter 4")]), _vm._v(" "), _c('span', {
    staticClass: "titalic"
  }, [_vm._v("A Trauma Worse Than Death")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-no"
  }, [_vm._v("Chapter 5")]), _vm._v(" "), _c('span', {
    staticClass: "titalic"
  }, [_vm._v("Identifying Trauma")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-no"
  }, [_vm._v("Chapter 6")]), _vm._v(" "), _c('span', {
    staticClass: "titalic"
  }, [_vm._v("Lies That Keep Us Stuck")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-no"
  }, [_vm._v("Chapter 7")]), _vm._v(" "), _c('span', {
    staticClass: "titalic"
  }, [_vm._v("The Generational Impact of Shame")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-no"
  }, [_vm._v("Chapter 8")]), _vm._v(" "), _c('span', {
    staticClass: "titalic"
  }, [_vm._v("A New View of Confession")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-no"
  }, [_vm._v("Chapter 9")]), _vm._v(" "), _c('span', {
    staticClass: "titalic"
  }, [_vm._v("The Power of Telling the Truth")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-no"
  }, [_vm._v("Chapter 10")]), _vm._v(" "), _c('span', {
    staticClass: "titalic"
  }, [_vm._v("Do You Want to be Well?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-no"
  }, [_vm._v("Chapter 11")]), _vm._v(" "), _c('span', {
    staticClass: "titalic"
  }, [_vm._v("What to Do with the Anger")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-no"
  }, [_vm._v("Chapter 12")]), _vm._v(" "), _c('span', {
    staticClass: "titalic"
  }, [_vm._v("Making Peace with the Pain")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-no"
  }, [_vm._v("Chapter 13")]), _vm._v(" "), _c('span', {
    staticClass: "titalic"
  }, [_vm._v("Embracing Freedom")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-no"
  }, [_vm._v("Chapter 14")]), _vm._v(" "), _c('span', {
    staticClass: "titalic"
  }, [_vm._v("Rewriting Your Ending")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-no"
  }, [_vm._v("Chapter 15")]), _vm._v(" "), _c('span', {
    staticClass: "titalic"
  }, [_vm._v("It’s Just Not Perfect Here")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-no"
  }, [_vm._v("Conclusion")]), _vm._v(" "), _c('span', {
    staticClass: "titalic"
  }, [_vm._v("Is That Too Much for You?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Endnotes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Next Steps")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a03f5252","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 75
// module chunks = 0